import { gql } from '@common/hooks';
import { OFFER_INFO_DETAILS_FRAGMENT } from './offer-info-details-fragments';
import { HistoryInfoFragment } from '@common/graphql/fragments';

export const OFFER_HEADER_INFO_FRAGMENT = gql`
  fragment OfferHeaderInfo on Offer {
    id
    state
    stateChangedAt
    rejectionReason
    rejectionDetails
  }
`;

export const OFFER_INFO_FRAGMENT = gql`
  fragment OfferBodyInfo on Offer {
    id
    offerChangeRequests {
      id
      createdAt
      offerChangeResponse {
        id
        detail {
          ... on OfferAcceptanceResponseDetail {
            id
            oldBillingRegularRate
          }
        }
      }
    }
    ...OfferDetailsInfo
    ...OfferHeaderInfo
  }
  ${OFFER_INFO_DETAILS_FRAGMENT}
  ${OFFER_HEADER_INFO_FRAGMENT}
`;

export const OFFER_CONFIRMATION_DRAWER_INFO_FRAGMENT = gql`
  fragment OfferConfirmationDrawerInfo on Offer {
    id
    canAccept {
      value
    }
    canReject {
      value
    }
    ...OfferBodyInfo
    history {
      ...HistoryInfoFragment
    }
    offerChangeRequests {
      id
      note
      createdAt
      updatedAt
      offerChangeResponse {
        id
        note
        updatedAt
      }
      worksMembership {
        id
        name
      }
    }
  }
  ${OFFER_INFO_FRAGMENT}
  ${HistoryInfoFragment}
`;
